import React from 'react'
import { Bar } from 'react-chartjs-2'
import { generateRandomColor } from '../../shared/constants'

const SingleBarGraph = ({ schemeEarning }) => {
  let tempArray = [[], [], [], []]
  Object.values(schemeEarning).forEach((val, index) => {
    val.forEach((val2, index2) => {
      tempArray[index2].push(val2)
    })
  })
  //console.log('TEMP ARRYA : ', tempArray)

  const randomColors = generateRandomColor(tempArray)
  //console.log('TEMP ATRRAY :', randomColors)
  let tempDataSets =
    schemeEarning &&
    tempArray.map((item, index) => {
      return {
        label: `Quarter ${index + 1}`,
        data: item,
        backgroundColor: randomColors[index],
      }
    })

  const data = {
    labels: Object.keys(schemeEarning).map((item) => item),
    datasets: tempDataSets,
  }
  const options = {
    legend: {
      display: true,
      position: 'bottom',
    },
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
          },
        },
      ],
    },
  }
  return (
    <>
      <Bar data={data} options={options} />
    </>
  )
}

export default SingleBarGraph
